import React from 'react';
import { HexColorPicker } from 'react-colorful';

const ColorWheel = ({ color, onChange }) => {
  return (
    <div style={{ textAlign: 'center' }}>
      <HexColorPicker color={color} onChange={onChange} />
    </div>
  );
};

export default ColorWheel;
